import { useState } from 'react';
import { useAuth } from '../App.jsx';
import { api } from '../api.js';
import Modal from './Modal.jsx';

export default function PasswordChangeDialog() {
  const { user, refresh } = useAuth();
  const [current, setCurrent] = useState(''), [next, setNext] = useState(''), [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  if (!user?.mustChangePassword) return null;
  async function submit(e) {
    e.preventDefault(); setError('');
    if (next !== confirm) { setError('The new passwords do not match.'); return; }
    setBusy(true);
    try { await api.auth.changePassword(current, next); await refresh(); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <Modal open onClose={() => {}} width={480}>
    <div className="dhead"><div><h2>Choose your password</h2><p className="sub">Your administrator gave you a temporary password. Replace it before continuing.</p></div></div>
    <form onSubmit={submit}><div className="dbody tenant-form">
      {error && <p className="formerror" role="alert">{error}</p>}
      <label className="field">Temporary password<input type="password" autoComplete="current-password" value={current} onChange={e => setCurrent(e.target.value)} required /></label>
      <label className="field">New password<input type="password" autoComplete="new-password" minLength={10} value={next} onChange={e => setNext(e.target.value)} required /></label>
      <label className="field">Confirm new password<input type="password" autoComplete="new-password" minLength={10} value={confirm} onChange={e => setConfirm(e.target.value)} required /></label>
    </div><div className="dfoot"><button className="btn primary" disabled={busy}>{busy ? 'Updating…' : 'Set password'}</button></div></form>
  </Modal>;
}
